import i18next from 'i18next';

import utilsXLS from '@commons/utils/makeXLS';

const BATCH_INGREDIENTS_UPDATE_IMPORT_ERRORS = {
  // Ingredient
  '200-unit-mismatch': 'UNIT_MISMATCH',
  '200-invalid-name': 'INVALID_NAME',
  '200-invalid-is-strategic': 'INVALID_IS_STRATEGIC',
  '200-invalid-is-edible': 'INVALID_IS_EDIBLE',
  '200-cost-mismatch': 'COST_MISMATCH',
  '200-category-not-found': 'CATEGORY_NOT_FOUND',
  '200-ingredient-not-found': 'INGREDIENT_NOT_FOUND',

  // Buffer stock
  '200-buffer-stock-store-not-found': 'BUFFER_STOCK_STORE_NOT_FOUND',
  '200-buffer-stock-sspm-not-found': 'BUFFER_STOCK_SSPM_NOT_FOUND',
  '200-buffer-stock-value-greater-than-prev-horizon-future-date':
    'BUFFER_STOCK_VALUE_GREATER_THAN_PREV_HORIZON_FUTURE',
  '200-buffer-stock-value-not-a-number': 'BUFFER_STOCK_VALUE_NOT_A_NUMBER',

  // Non sales consumption
  '200-non-sales-consumption-missing-frequency-or-quantity': 'NSC_MISSING_FREQUENCY_OR_QUANTITY',
  '200-non-sales-consumption-store-not-found': 'NSC_STORE_NOT_FOUND',
  '200-non-sales-consumption-sspm-not-found': 'NSC_SSPM_NOT_FOUND',
  '200-non-sales-consumption-invalid-frequency': 'NSC_INVALID_FREQUENCY',
  '200-non-sales-consumption-invalid-quantity': 'NSC_INVALID_QUANTITY',
};

const formatUnValidatedDataForExport = (unvalidatedData, prevHorizonFuture) =>
  unvalidatedData.map((item) => ({
    ...item,
    error: i18next.t(
      `_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.ERRORS.${
        BATCH_INGREDIENTS_UPDATE_IMPORT_ERRORS[item.error]
      }`,
      { prevHorizonFuture: prevHorizonFuture },
    ),
  }));

const getIngredientsColumns = () => [
  { propertyKey: 'name', name: i18next.t('GENERAL.NAME') },
  {
    propertyKey: 'error',
    name: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.LIST_COLUMN_ERROR'),
  },
];

const getBFAndNSCColumns = (clientStoreName) => [
  { propertyKey: 'name', name: i18next.t('GENERAL.NAME') },
  { propertyKey: 'storeName', name: clientStoreName },
  {
    propertyKey: 'error',
    name: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.LIST_COLUMN_ERROR'),
  },
];

export const getImportErrorFileConfig = (
  unValidatedIngredients,
  unValidatedBufferStocks,
  unValidatedNonSalesConsumptions,
  prevHorizonFuture = 14,
  clientStoreName,
) => {
  const formattedUnValidatedIngredients = formatUnValidatedDataForExport(
    unValidatedIngredients,
    prevHorizonFuture,
  );
  const formattedUnValidatedBufferStocks = formatUnValidatedDataForExport(
    unValidatedBufferStocks,
    prevHorizonFuture,
  );
  const formattedUnValidatedNonSalesConsumptions = formatUnValidatedDataForExport(
    unValidatedNonSalesConsumptions,
    prevHorizonFuture,
  );

  const ingredientsSheet = utilsXLS.generateDefaultSheet(
    i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.INGREDIENTS_SHEET_NAME'),
    getIngredientsColumns(),
    formattedUnValidatedIngredients,
  );

  const bufferStockSheet = utilsXLS.generateDefaultSheet(
    i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.BUFFER_STOCK_SHEET_NAME'),
    getBFAndNSCColumns(clientStoreName),
    formattedUnValidatedBufferStocks,
  );

  const nonSalesConsumptionSheet = utilsXLS.generateDefaultSheet(
    i18next.t(
      '_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.NON_SALES_CONSUMPTION_SHEET_NAME',
    ),
    getBFAndNSCColumns(clientStoreName),
    formattedUnValidatedNonSalesConsumptions,
  );

  utilsXLS.makeXLS(
    i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.IMPORT_ERROR_FILE_TITLE'),
    [ingredientsSheet, bufferStockSheet, nonSalesConsumptionSheet],
  );
};
